<button id="openCancelPlan" [hidden]="true" data-toggle="modal" data-target="#cancelPlan">CancelPlan</button>
<app-toasts
    *ngIf="toastVisible"
    [toastType]="toastType"
    [content]="toastMessage"
    [(visible)]="toastVisible"
    (closeToast)="closeToast()">
</app-toasts>
<div class="modal fade" id="cancelPlan" tabindex="-1" role="dialog" aria-labelledby="Cancel Plan" aria-hidden="true" #cancelPlan>
    <div class="modal-dialog modal modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header col-xs-12 col-md-12">
                <div class="closeModal">
                    <img src="../../../assets/images/cross.svg" style="cursor: pointer;" data-toggle="modal" data-target="#cancelPlan">
                </div>
            </div>
            <div class="modal-body">
                <div class="col-md-12 col-xs-12">
                    <div class="font18px">
                        <span>Are you sure you want to cancel?</span>
                    </div>
                    <div class="martop10px font16px contactInfo">
                        <div>Email our support team at
                        <a href="mailto:support@domii.io" style="color: #CE0000;">
                       support@domii.io
                       </a>
                       </div>
                    </div>
                    <!-- <div class="martop20px font18px">
                        <span>Or Send Email, We will reach you back!!</span>
                    </div> -->
                    <div class="martop10px">
                        <form class="cancelPlanForm" (ngSubmit)="onSubmit()" #cancelPlanForm="ngForm">
                            <div>
                                <div class="form-group">
                                    <label for="contact">Contact Number</label>
                                    <input type="phone" class="form-control" id="contact" name="contact" required
                                        placeholder="Enter Your Contact Number" #contact="ngModel"
                                        [ngClass]="{'is-invalid': submitted && contact.errors}"
                                        [(ngModel)]="mobile"  maxlength="12">
                                    <div class="invalid-feedback" *ngIf="submitted && contact.errors">
                                        <span *ngIf="contact.errors.required">Please enter Contact Number</span>
                                        <span *ngIf="contact.errors.pattern">Please enter Valid Contact Number</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="form-group">
                                    <label for="email">Email ID</label>
                                    <input type="email" class="form-control" id="email" name="email" required
                                        placeholder="Enter Your Email ID" #email="ngModel"
                                        [ngClass]="{'is-invalid': (submitted || email.dirty) && email.errors}"
                                        [(ngModel)]="emailID" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$">
                                    <div class="invalid-feedback" *ngIf="(submitted || email.dirty) && email.errors">
                                        <span *ngIf="email.errors.required">Please enter Email ID</span>
                                        <span *ngIf="email.errors.pattern">Please enter Valid Email</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="form-group">
                                    <label for="reason">
                                        Reason to Cancel <span style="color: #838282;">(Optional)</span>
                                    </label>
                                    <textarea class="form-control" id="reason" name="reason" [(ngModel)]="reasonToCancel"
                                        #reason="ngModel">
                                    </textarea>
                                </div>
                            </div>
                            <div class="flexDspl martop20px">
                                <button type="submit" class="btn submitButton">Send</button>
                                <span class="formErrMsg" *ngIf="submitted && cancelPlanForm.form.invalid">*Enter All the Fields</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>